import { AdSize } from './model/wrapper-ads.types';

export const AD_BANNER_HEIGHT_BY_SIZE: Record<AdSize, number> = {
  [AdSize.SMALL]: 128,
  [AdSize.MEDIUM]: 146,
  [AdSize.LARGE]: 256,
};
